import { AnimatedTheme } from "../.internal/themes/AnimatedTheme";
export default AnimatedTheme;